import { useState } from 'react'
import Card from 'react-bootstrap/Card'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import ProgressBar from 'react-bootstrap/ProgressBar'
import { calculatePercent } from 'helpers/utils'
import { formatDateTime } from 'helpers/datetime'

const SampleCard = ({ sample, onClick }) => {
  const [mouseOver, setMouseOver] = useState(false)
  const isGenerating = sample.status === 'generating'

  const cardStyle = {
    cursor: isGenerating ? 'default' : 'pointer',
    border: !isGenerating && mouseOver ? '1px solid #1E2E48' : '1px solid #dee2e6',
    transition: 'border-color 0.15s ease-in-out',
    opacity: isGenerating ? 0.5 : 1
  }

  const handleClick = () => {
    if (!isGenerating) onClick(sample.id)
  }

  const pct = calculatePercent(sample.complete_count, sample.total_count)

  return (
    <Card
      className="mb-3 shadow-sm"
      style={cardStyle}
      onClick={handleClick}
      onMouseEnter={() => !isGenerating && setMouseOver(true)}
      onMouseLeave={() => setMouseOver(false)}
    >
      <Card.Body>
        <Row className="align-items-center">
          <Col>
            <div className="fw-semibold mb-1">
              {sample.name}
            </div>
            <small className="text-muted mb-2 d-block">
              {formatDateTime(sample.created_at)}
            </small>
          </Col>
          <Col sm="auto">
            <small className="text-muted">
              {sample.total_count} transactions
            </small>
          </Col>
        </Row>

        {sample.status === 'available' && (
          <Row className="mt-2 align-items-center">
            <Col>
              <ProgressBar now={pct} style={{ height: '10px' }} />
            </Col>
            <Col sm="auto">
              <small className="fw-semibold">{pct}% Complete</small>
            </Col>
          </Row>
        )}
      </Card.Body>
    </Card>
  )
}

export default SampleCard
